import Swiper, { Navigation, Autoplay } from 'swiper';

// Register modules globally
Swiper.use([Navigation, Autoplay]);

export default class PartnerArticlesWidget {
  /**
   * @param swiperContainer {HTMLElement}
   */
  constructor({ swiperContainer }) {
    this.dom = {
      swiperContainer,
      swiperParentContainer: swiperContainer.parentElement,
    };

    this.components = {
      swiperInstance: null,
    };
  }

  /**
   * @returns {this}
   */
  mount() {
    this.components.swiperInstance = new Swiper(this.dom.swiperContainer, {
      modules: [Autoplay, Navigation],
      loop: true,
      slidesPerView: 1,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: this.dom.swiperParentContainer.querySelector('.swiper-button-next'),
        prevEl: this.dom.swiperParentContainer.querySelector('.swiper-button-prev'),
      },
    });

    return this;
  }
}
